"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addText = exports.render = exports.clear = exports.update = exports.setVisible = exports.setOpen = exports.assign = exports.create = void 0;
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageUiGButtons_sidecar_1 = require("@voyage/ui/voyageUiGButtons-sidecar");
var voyageUiGraphicsUtils_sidecar_1 = require("@voyage/ui/voyageUiGraphicsUtils-sidecar");
function create(targetWidth, targetHeight, parentLayer) {
    if (parentLayer === void 0) { parentLayer = null; }
    var layer = parentLayer !== null && parentLayer !== void 0 ? parentLayer : voyageLayers_sidecar_1.voyageLayers.getLayers().uiGame;
    layer = voyageLayers_sidecar_1.voyageLayers.createExternal(layer);
    var g = voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.createGraphics(layer);
    var obj = {
        isOpen: false,
        // panel,
        graphics: g,
        texts: [],
        buttons: [],
        // selectors: [],
        targetWidth: targetWidth,
        targetHeight: targetHeight,
        ox: 0,
        oy: 0,
        layer: layer,
        autoOffset: true,
    };
    g.setInteractive({
        cursor: 'pointer',
        hitAreaCallback: function (_, x, y) {
            if (!obj.isOpen) {
                return false;
            }
            return voyageUiGButtons_sidecar_1.voyageUiGButtons.hitTest(obj.buttons, x, y, false);
            //goatGSelectors.hitTest(obj.selectors, x, y, true)
        },
    });
    return obj;
}
exports.create = create;
function assign(canv, up) {
    return Object.assign(canv, up);
}
exports.assign = assign;
function setOpen(obj, isOpen) {
    obj.isOpen = isOpen;
    setVisible(obj, isOpen);
}
exports.setOpen = setOpen;
function setVisible(obj, isVisible) {
    // goatPanels.setVisible(obj.panel, isVisible)
}
exports.setVisible = setVisible;
function update(obj) {
    var mp = voyageCamera_sidecar_1.voyageCamera.getUiMousePosition();
    var l = obj.layer;
    if (!l.visible) {
        return;
    }
    if (!obj.isOpen) {
        return;
    }
    // Adjust graphics layer
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    // Adjust for different resolutions
    if (obj.autoOffset) {
        var ox = (gb.width - obj.targetWidth) / 2;
        var oy = (gb.height - obj.targetHeight) / 2;
        if (ox > 0 && obj.targetWidth) {
            l.x = ox;
        }
        else {
            l.x = 0;
        }
        if (oy > 0 && obj.targetHeight) {
            l.y = oy;
        }
        else {
            l.y = 0;
        }
    }
    else {
        l.x = 0;
        l.y = 0;
    }
    l.x += obj.ox;
    l.y += obj.oy;
    var mx = mp.mx - l.x;
    var my = mp.my - l.y;
    voyageUiGButtons_sidecar_1.voyageUiGButtons.hitTest(obj.buttons, mx, my, true);
    // goatGSelectors.hitTest(obj.selectors, mx, my, true)
    // render()
}
exports.update = update;
function clear(obj) {
    obj.texts = stevieTexts2_sidecar_1.stevieTexts2.killBulk(obj.texts);
    obj.graphics.clear();
}
exports.clear = clear;
function render(obj) {
    voyageUiGButtons_sidecar_1.voyageUiGButtons.render(obj.graphics, obj.buttons, obj.texts, obj.layer);
    //goatGSelectors.render(obj.graphics, obj.selectors, obj.texts, obj.panel.layer)
}
exports.render = render;
function addText(obj, text, x, y, scale) {
    if (scale === void 0) { scale = 2; }
    var _text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font6, x, y, obj.layer);
    stevieTexts2_sidecar_1.stevieTexts2.setText(_text, text);
    stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, scale);
    obj.texts.push(_text);
    return _text;
}
exports.addText = addText;
